import React, { useEffect, useMemo, useState } from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import { redirectTo } from "../redirectToPath";
import { useDispatch, useSelector } from "react-redux";
import { getProfileDetail } from "../../../Actions/ProfileAction";
import Layout from "../../../layout";
import { Loader } from "semantic-ui-react";
import { toggleSidebar } from "../../../Actions/componentActions"
import { getBrandBasePath, getBrandIntroductionPath } from "../pathUtils";

const CommonPrivateRoute = (props) => {

  const { component: Component, isuserRole = '',...rest } = props;
  const history = useHistory()
  let token = sessionStorage.getItem("ssoToken")
  const [userRole, setUserRole] = useState('')
  const [isLoader, setIsLoading] = useState(true)
  const profileDetail = useSelector(state => state?.profileReducer?.profileDetail)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(toggleSidebar(true))
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    fetchProfile();
    // eslint-disable-next-line
  }, [profileDetail?.data?.user?.role])

  const fetchProfile = async () => {
    if (profileDetail?.data?.user?.role) {
      setUserRole(profileDetail?.data?.user?.role)
      setIsLoading(false)
    } else {
      setIsLoading(true)
      await dispatch(getProfileDetail())
      setIsLoading(false)

    }
  };

  const brandBasePath = useMemo(() => {
    return getBrandBasePath(history?.location?.pathname)
  }, [history?.location?.pathname])

  const SwitchPage = (type) => {
    let switchPathName = redirectTo[type] || brandBasePath
    if (!type) return <Redirect to={brandBasePath} />
    if(type === 'entrepreneur') return <Redirect to={getBrandIntroductionPath(history?.location?.pathname)} />
    return <Redirect to={switchPathName} />
  }


  const hasSideBar = useMemo(() => {
    if (isuserRole?.includes('entrepreneur')) return false
    return !["entrepreneur"].includes(profileDetail?.data?.user?.role)
  }, [profileDetail?.data?.user?.role, isuserRole])

  return token ?
    <>
      <Layout hasSideBar={hasSideBar} isuserRole={isuserRole}>
        {!isLoader ?
          isuserRole.includes(userRole) ?
            <Route  {...rest} render={props => (
              <Component {...props} />
            )} />
            : SwitchPage(userRole)
          :
          <div className="h-full w-full flex flex-col items-center justify-center">
            <Loader size='big' active inline='centered' />
          </div>
        }
      </Layout>
    </>
    : SwitchPage()
}
export default CommonPrivateRoute;
